import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar } from './Avatar';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { AvatarName } from './AvatarName';
import { PentaMemberActions } from '../Penta/PentaMemberActions';


export function PentaPanel(props) {
  const {
    penta = {},
    member = {},
    callback = () => void (0),
  } = { ...props };
  const navigate = useNavigate();
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) }
  const $ui = context.$ui;

  const $type = context.$type;
  const $profile = context.$profile;


  return (
    <div className='x_penta_member'>

{
  member.avatar?.token
  && Boolean(context.me)
  && penta.my !== false
  && <>
    <PentaMemberActions
      style={{zIndex: 2}}
      penta={penta}
      avatar={member.avatar}
      callback={callback}
    />
  </>}

      {member && member.avatar && <div className="x_calc_result_name_penta" style={{ cursor: 'pointer', zIndex: 1 }}
        // onClick={(e) => {
        //   e.stopPropagation();
        //   e.preventDefault();
        //   navigate(`/u/${member.user ? member.user.token : member.avatar.token}`)
        // }}
      >



        <Avatar
          onClick={e => e.stopPropagation()}
          avatar={member.avatar}
          type=''
        />

        <div className="x_calc_result_title x_calc_result_title--penta ellipsis">

          <AvatarName avatar={member.avatar} className='' />

          {/* {member.avatar.name ? member.avatar.name : context.getDefaultTitle(member.avatar.design)} */}
          </div>

      </div>}



    </div>
  )
}
